<div class="basic-form no-gutters" *transloco="let t">
  <form class="col" [formGroup]="basicForm" (ngSubmit)="onSubmit()">
    <div class="row no-gutters">
      <div class="form-group col-12">
        <app-text-input [childForm]="basicForm" formControlName="officialName" [label]="t('settings/name')"></app-text-input>
      </div>
      <div class="col-md col-12">
        <div class="row no-gutters">
          <div class="form-group col-12">
            <app-text-input [childForm]="basicForm" formControlName="lawId" [label]="t('settings/lawId')"></app-text-input>
          </div>
          <div class="form-group col-12">
            <app-text-input [childForm]="basicForm" formControlName="website" [label]="t('settings/website')"></app-text-input>
          </div>
        </div>
      </div>
      <div class="col-md col-12 mt-md-0 mt-4">
        <div class="row no-gutters">
          <div class="form-group col-12">
            <app-text-input [childForm]="basicForm" formControlName="redIzo" [label]="t('settings/redIzo')"></app-text-input>
          </div>
          <div class="form-group col-12">
            <app-text-input [childForm]="basicForm" formControlName="databox" [label]="t('settings/databox')"></app-text-input>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="row no-gutters">
      <div class="d-flex justify-content-end col">
        <button class="btn btn-lg btn-primary" [disabled]="basicForm.invalid">
          {{ t('shared/save') }}
        </button>
      </div>
    </div>
  </form>
</div>
